import { render, staticRenderFns } from "./LegalDocument.vue?vue&type=template&id=7b5b411f&scoped=true"
import script from "./LegalDocument.vue?vue&type=script&lang=js"
export * from "./LegalDocument.vue?vue&type=script&lang=js"
import style0 from "./LegalDocument.vue?vue&type=style&index=0&id=7b5b411f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5b411f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b5b411f')) {
      api.createRecord('7b5b411f', component.options)
    } else {
      api.reload('7b5b411f', component.options)
    }
    module.hot.accept("./LegalDocument.vue?vue&type=template&id=7b5b411f&scoped=true", function () {
      api.rerender('7b5b411f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/LegalDocument.vue"
export default component.exports